import { GET_SHOP_DETAILS } from "../constants/endpoints";
import axiosClient from "./axios";

class shopDetailsService {
  static async getShopDetails(id: string) {
    return await axiosClient.get(`${GET_SHOP_DETAILS}/${id}`);
  }
}

export default shopDetailsService;
